import type { Placement } from '@atlaskit/popper/popper';

import { POSITION_ATTRIBUTE_ENUM } from './POSITION_ATTRIBUTE_ENUM';
type PositionMap = {
	[key: string]: {
		animation: 'top' | 'bottom' | 'left' | 'right';
		position: Placement;
	};
};

const positionMap: PositionMap = {
	'top left': { position: 'top-start', animation: 'top' },
	'top center': { position: 'top', animation: 'top' },
	'top right': { position: 'top-end', animation: 'top' },
	'right top': { position: 'right-start', animation: 'right' },
	'right middle': { position: 'right', animation: 'right' },
	'right bottom': { position: 'right-end', animation: 'right' },
	'bottom left': { position: 'bottom-start', animation: 'bottom' },
	'bottom center': { position: 'bottom', animation: 'bottom' },
	'bottom right': { position: 'bottom-end', animation: 'bottom' },
	'left top': { position: 'left-start', animation: 'left' },
	'left middle': { position: 'left', animation: 'left' },
	'left bottom': { position: 'left-end', animation: 'left' },
};

function positionToPopper(position: string) {
	return position && positionMap[position] ? positionMap[position].position : null;
}

export function positionPropToPopperPosition(position: string): Placement {
	return positionToPopper(position) || positionMap[POSITION_ATTRIBUTE_ENUM.default].position;
}
// eslint-disable-next-line @atlaskit/editor/no-re-export
